/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Provider, useDispatch } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import * as Jetemit from 'jetemit';
import { HashRouter as Router, Switch, Redirect, useHistory } from "react-router-dom";
import "moment/locale/es";
import { Route } from "components";
import { Socket, SocketEvents, Globals } from 'utils';
import { AuthService } from 'services';
import { store, persistor } from "./store";

// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

// Public
import Home from 'screens/home';

// Auth
import Login from "screens/auth/login/login";
import Recover from "screens/auth/login/recover";
import Reset from "screens/auth/login/reset";
import Profile from "screens/profile";
import SuccessPassword from "screens/success-password";

// Admin Home
import Admin from 'screens/admin/home';
import AdminAppointments from 'screens/admin/appointments/appointments';
import AdminBanners from 'screens/admin/banners/banners';
import AdminChat from 'screens/admin/chat/chat';
import AdminHome from 'screens/admin/home';
import AdminPlans from 'screens/admin/plans/plans';
import AdminRatings from 'screens/admin/ratings/ratings';
import AdminReportsPayments from 'screens/admin/reports/payments/payments';
import AdminReportsPaymentsManage from 'screens/admin/reports/management-payments/manage';
import AdminReportsPlans from 'screens/admin/reports/plans/plans';
import AdminReportsAppoinments from 'screens/admin/reports/appointments/appointments';
import AdminServices from 'screens/admin/services/services';
import AdminUsers from 'screens/admin/users/users';

// Scripts
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./scss/main.scss";

const Container = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const getUser = async () => {
      const user = store.getState().user;
      if (user) {
        const res: any = await AuthService.checkUser({
          user_id: user?.id,
          withoutLoading: true
        });
        if (res.user) {
          dispatch({
            type: 'SET_USER',
            payload: res.user
          });
        }
        else {
          Globals.showError("Lo sentimos, su usuario ha sido eliminado");
          close();
        }
      }
    }
    getUser();

    const close = async () => {
      await dispatch({ type: 'SET_USER', payload: null });
      history.replace('/logout');
    }

    Socket.on(SocketEvents.UPDATE_USER, (data: any) => {
      const user = store.getState().user;
      if (user != null && user?.id === data.user_id) {
        getUser();
      }
    });

    Socket.on(SocketEvents.CHATS.MESSAGE, (data: any) => {
      Jetemit.emit(SocketEvents.CHATS.MESSAGE, data);
    });

    Socket.on(SocketEvents.CHATS.DELETE, (data: any) => {
      Jetemit.emit(SocketEvents.CHATS.DELETE, data);
    });

    Socket.on(SocketEvents.CHATS.EDIT, (data: any) => {
      Jetemit.emit(SocketEvents.CHATS.EDIT, data);
    });
  }, []);

  return (
    <React.Fragment>
      <Switch>
        {/* Public */}
        <Route exact path="/" component={Home} />
        <Route exact path="/success-password" component={SuccessPassword} />

        {/* Auth */}
        <Route exact noAuth path="/login" component={Login} />
        <Route exact auth path="/profile" component={Profile} />
        <Route exact noAuth path="/recover" component={Recover} />
        <Route exact noAuth path="/recover/:code" component={Reset} />

        {/* Admin */}

        {/* Admin */}
        <Route exact admin path="/admin" component={Admin} />
        <Route exact admin path="/admin/appointments" component={AdminAppointments} />
        <Route exact admin path="/admin/banners" component={AdminBanners} />
        <Route exact admin path="/admin/chat" component={AdminChat} />
        <Route exact admin path="/admin/home" component={AdminHome} />
        <Route exact admin path="/admin/plans" component={AdminPlans} />
        <Route exact admin path="/admin/ratings" component={AdminRatings} />
        <Route exact admin path="/admin/reports/payments" component={AdminReportsPayments} />
        <Route exact admin path="/admin/reports/payments/manage" component={AdminReportsPaymentsManage} />
        <Route exact admin path="/admin/reports/plans" component={AdminReportsPlans} />
        <Route exact admin path="/admin/reports/appointments" component={AdminReportsAppoinments} />
        <Route exact admin path="/admin/services" component={AdminServices} />
        <Route exact admin path="/admin/users" component={AdminUsers} />
        <Redirect to="/" />
      </Switch>
    </React.Fragment>
  )
}

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Container />
      </Router>
    </PersistGate>
  </Provider>
);

export default App;
